<template>
  <div class="container">
    <div class="row faqs mx-auto mb-5">
      <div class="col-md-12">
        <h1 class="text-center mt-5 mb-5">
          {{ $t('Support.SupportTitle') }} <!-- Fetching title -->
        </h1>

        <div class="accordion" id="faqAccordion">
          <div class="card" v-for="(faq, index) in faqs" :key="index"> <!-- Loop through faqs -->
            <div class="card-header" :id="'heading' + index">
              <h2 class="accordion-header">
                <button
                  :class="{
                    'arrow-open': activeIndex === index,
                    'arrow-closed': activeIndex !== index,
                  }"
                  class="accordion-button"
                  type="button"
                  @click="toggle(index)"
                  :aria-expanded="activeIndex === index ? 'true' : 'false'"
                  :aria-controls="'collapse' + index"
                >
                  <span v-html="faq.question"></span> <!-- Fetch question -->
                </button>
              </h2>
            </div>
              <div
              :id="'collapse' + index"
              class="accordion-collapse collapse"
              :class="{ show: activeIndex === index }"
              :aria-labelledby="'heading' + index"
              data-bs-parent="#faqAccordion"
            >
              <div class="card-body" v-html="faq.answer"></div> <!-- Fetch answer -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FAQ',
  data() {
    return {
      faqs: [],
      activeIndex: null,
    };
  },
  created() {
    this.loadFaqs(); // Load FAQs when component is created
  },
  watch: {
    '$i18n.locale': 'loadFaqs', // Reload FAQs when locale changes
  },
  methods: {
    async loadFaqs() {
      try {
        const currentLocale = this.$i18n.locale;
        const response = await fetch(`/locales/${currentLocale}.json`);
        const data = await response.json();
        
        if (data && data.Support) {
          this.faqs = data.Support.faqs;
        } else {
          console.error('Invalid FAQ data structure in', currentLocale);
          this.faqs = [];
        }
      } catch (error) {
        console.error('Error loading FAQs:', error);
        this.faqs = [];
      }
    },
    toggle(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    },
  },
};
</script>
<style scoped>
#faqAccordion>.card {
  margin-bottom: 15px;
  border-radius: 0px;
  border: 2px solid #ca1246;
  background: transparent;
}

#faqAccordion>.card>.card-header {
  padding: 0px;
  background: transparent;
  border-color: #ca1246;
}

#faqAccordion .accordion-button {
  font-size: 1.5rem;
  color: #000000;
  font-weight: 600;
  padding: 15px 30px 15px 15px;
  box-shadow: none;
  background: transparent;
}

#faqAccordion .accordion-button:focus,
#faqAccordion .accordion-button.focus,
#faqAccordion .accordion-button:hover {
  text-decoration: none;
}

.accordion-button:not(.collapsed) {
  background-color: #e9ecef;
}

.accordion-button {
  transition: background-color 0.3s ease;
}

.accordion-button::after,
.accordion-button:not(.collapsed)::after {
  font-family: 'FontAwesome';
  background-image: none;
}

.accordion-button.arrow-open::after {
  content: '\f078';
}

.accordion-button.arrow-closed::after {
  content: '\f077';
}

@media screen and (max-width: 767px) {
  #faqAccordion .accordion-button {
    font-size: 1.2rem;
  }
}
</style>